/**
 * Public comparison floor verified 2026-07-13 against release-level counts
 * published by major music-catalog services. Discogs was the largest comparable
 * single-source catalog found, publicly reported at more than 19 million release
 * listings; MusicBrainz reported 5,619,773 releases on 2026-07-09.
 */
export const LARGEST_CATALOG_COMPARISON_FLOOR = 19_000_000;
export const LARGEST_CATALOG_VERIFIED_ON = "2026-07-13";

export function hasLargestCatalogEvidence(
  stats: { physicalReleaseCount: number } | null | undefined,
): boolean {
  return Boolean(stats && stats.physicalReleaseCount > LARGEST_CATALOG_COMPARISON_FLOOR);
}
